class BankRequestDTO {
	constructor({
		name,
		taxId,
		bank,
		number,
		agency,
		account,
		step,
	}) {
		this.name = name;
		this.taxId = taxId;
		this.bank = bank;
		this.number = number;
		this.agency = agency;
		this.account = account;
		this.selectedBank = "";
		this.step = step;
	}
}

export default BankRequestDTO;
